import axios from "axios";
import { API_BASE_URL, FETCH_LIMIT } from "../../globalVars";

export default {
  namespaced: true,

  actions: {
    async hydrate({ commit }, lastUpdateTime = null) {
      const store = this;
      const last = this.getters["entities/settings/query"]().first()
        .lastUpdateFromServer;
      await fetchNext({
        store: store,
        offset: 0,
        lastDateTime: lastUpdateTime ? lastUpdateTime : last ? last : 0
      });
    },

    async updateUserPreferences(context, userPreference) {
      const store = this;
      let oldUser = this.getters["entities/userPreferences/query"]().first() || {};
      let response;
      if (
        !(
          oldUser &&
          userPreference &&
          oldUser.accountId == userPreference.accountId &&
          oldUser.userId == userPreference.userId &&
          JSON.stringify(oldUser.calendarPreferences) ==
            JSON.stringify(userPreference.calendarPreferences) &&
          JSON.stringify(oldUser.telecomPreferences) ==
            JSON.stringify(userPreference.telecomPreferences) &&
          JSON.stringify(oldUser.reportPreferences) ==
            JSON.stringify(userPreference.reportPreferences)
        ) ||
        (userPreference && userPreference.isDirty === true)
      ) {
        const oldAccount = this.getters["entities/accounts/query"]().first();
        const accountId = oldAccount.id;
        let data = {
          accountId: accountId,
          userId: userPreference.userId,
          config: {
            calendar: userPreference.calendarPreferences
              ? userPreference.calendarPreferences
              : oldUser.calendarPreferences,
            telecom: userPreference.telecomPreferences
              ? userPreference.telecomPreferences
              : oldUser.telecomPreferences,
            report: userPreference.reportPreferences
              ? userPreference.reportPreferences
              : oldUser.reportPreferences
          }
        };
        if (userPreference.id) {
          response = await axios({
            method: "patch",
            url: API_BASE_URL + `/user-preferences/${userPreference.id}`,
            data: data,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          }).catch(error => {
            if (error.response.data.message) {
              store.dispatch("entities/settings/update", {
                where: 1,
                data: {
                  serverErrorMessage: error.response.data.message
                }
              });
            } else {
              store.dispatch("entities/settings/setIsOffline", true);
            }
          });
        }
        if (response && response.data) {
          let userPreferences = response.data || {};
          userPreferences.calendarPreferences = {};
          userPreferences.telecomPreferences = {};
          userPreferences.reportPreferences = {};
          const obj = response.data;
          let results = obj && obj.config ? obj.config : {};
          if (results.calendar) {
            userPreferences.calendarPreferences = results.calendar;
          }
          if (results.telecom) {
            userPreferences.telecomPreferences = results.telecom;
          }
          if (results.report) {
            userPreferences.reportPreferences = results.report;
          }
          store.dispatch("entities/userPreferences/update", {
            where: userPreferences.id,
            data: userPreferences
          });
          store.dispatch("entities/settings/setIsOffline", false);
          store.dispatch("entities/settings/update", {
            where: 1,
            data: {
              serverErrorMessage: null
            }
          });
        }
      }
    }
  }
};

async function fetchNext({ store }) {
  try {
    let response = await axios({
      method: "get",
      url: API_BASE_URL + `/user-preferences`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      }
    });
    const obj = response.data.data[0];
    let results = obj && obj.config ? obj.config : {};

    let userPreferences = {};
    if (results.calendar) {
      userPreferences.calendar = results.calendar;
    } else {
      userPreferences.calendar = {};
    }
    if (results.telecom) {
      userPreferences.telecom = results.telecom;
    } else {
      userPreferences.telecom = {};
    }
    if (results.report) {
      userPreferences.report = results.report;
    } else {
      userPreferences.report = {};
    }
    await store.dispatch("entities/userPreferences/create", {
      data: {
        id: obj.id,
        calendarPreferences: userPreferences.calendar,
        telecomPreferences: userPreferences.telecom,
        reportPreferences: userPreferences.report
      }
    });
  } catch (error) {
    if (
      error.response &&
      error.response.data.message == "Access Denied: User Not Authorized"
    ) {
      window.location("/error/not-authorized");
    } else {
      console.error("userPreferences", error);
      await store.dispatch("entities/settings/setIsOffline", true);
    }
  }
}
